<template>
  <div>
    <question @submit="addQa"></question>
    <z-pagination :desc="desc" :loading="loading" :spinning="spinning" :total="total" :empty="false" @loadData="loadData" @empty="toPost">
      <comment v-for="item in postList" :key="item.id" :commentData="item" :infoOpers="['del', 'watch', 'like', 'reply']"></comment>
    </z-pagination>
    <!-- <add-modal :visible.sync="visible" @refresh="addTheme(params)"></add-modal> -->
    <!-- <a-spin :spinning="spinning">
      <div class="comments" v-show="postList && postList.length > 0">
        <comment
          v-for="item in postList"
          :key="item.id"
          :commentData="item"></comment>
        <a-pagination
          :defaultPageSize="params.limit"
          v-model="current"
          :total="total"
          show-less-items
        />
      </div>
    </a-spin> -->
    <!-- <a-empty
      v-if="empty"
      image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
    /> -->
    <!-- <z-modal destroyOnClose :loading="loading" :visible="visible" title="新建提问" :width="434" @close="visible = false" @submit="addQa">
      <a-form-model ref="addForm" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="问题归属" prop="planclassesId">
          <a-select placeholder="请选择" style="width: 100%" v-model="form.classesId">
            <a-select-option :value="item.classesId" v-for="item in classesList" :key="item.classesId">
              {{ item.classesName || item.classesId }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="内容" prop="content">
          <a-input v-model="form.content" type="textarea" :rows="6" />
        </a-form-model-item>
        <a-form-model-item label="图片">
          <upload listType="picture-card" path="img/art/" @uploadChange="uploadChange"></upload>
        </a-form-model-item>
      </a-form-model>
    </z-modal> -->
  </div>
</template>
<script>
import zPagination from '@/components/ZPagination'
import comment from '../../../components/Comment.vue'
import question from '../../../components/Question.vue'
// import addModal from './addModal'
// import zModal from '@/components/ZModal'
// import upload from '@/components/Upload'
import { addTheme, findClassesDetail } from '@/api/myQa'
export default {
  name: '',
  data() {
    return {
      desc: '什么都没有~快去发帖或者参与讨论吧~',
      // current: 1,
      visible: false,
      loading: false,
      params: {
        limit: 10,
        page: 0,
        meFlag: 0,
        planclassesId: '',
        classesId: ''
      },
      total: 0,
      postList: [],
      spinning: true
    }
  },
  components: {
    comment,
    question,
    zPagination,
    // addModal,
    // zModal,
    // upload,
  },
  props: {
    planclassesId: {
      type: String,
      required: false,
      default: 'dark'
    },
    classesId: {
      type: String,
      required: false,
      default: 'dark'
    }
  },
  watch: {
    // 'params.classesId'(val, oldVal) {
    //   if (!oldVal) return
    //   const { classesName, ...data } = this.classesList.find(item => item.classesId === val)
    //   // console.log(data)
    //   this.form.classesId = data.classesId
    //   Object.assign(this.params, data)
    //   this.findClassesDetailAsync(this.params)
    // },
    // 'form.classesId'(val, oldVal) {
    //   if (!oldVal) return
    //   const { classesName, ...data } = this.classesList.find(item => item.classesId === val)
    //   Object.assign(this.form, data)
    // },
    // current(val) {
    //   this.params.page = parseInt(val) - 1
    //   this.findClassesDetailAsync(this.params)
    // },
    // visible(val) {
    //   if (!val) {
    //     if (this.form.content) {
    //       this.form.planclassesId = ''
    //       this.form.content = ''
    //       this.params.page = 0
    //       this.findClassesDetailAsync(this.params)
    //     }
    //   }
    // }
  },
  created() {
    this.params.classesId = this.classesId
    this.params.planclassesId = this.planclassesId
    this.findClassesDetailAsync(this.params)
  },
  methods: {
    toPost() {
      this.visible = true
      // this.featchFun()
    },
    loadData(val) {
      this.params.page = parseInt(val) - 1
      this.findClassesDetailAsync(this.params)
    },
    // 获取贴子列表
    async findClassesDetailAsync(params) {
      try {
        !this.spinning && (this.spinning = true)
        const { list, themeNum } = await findClassesDetail(params)
        this.spinning = false
        this.postList = list
        this.total = themeNum
        this.empty = !themeNum
      } catch (error) {
        console.log(error)
      } finally {
        this.spinning = false
      }
    },
    async addQa(ev) {
      try {
        const res = await addTheme({
          ...ev,
          classesId: this.classesId,
          planclassesId: this.planclassesId
        })
        res && this.$message.success('添加成功')
        this.findClassesDetailAsync(this.params)
      } catch (error) {
        console.log(error)
      }
    },
    // 新增贴子
    // async addQa(ev) {
    //   console.log('add', ev)
    //   try {
    //     this.loading = true
    //     const res = await addTheme({
    //       ...ev,
    //       classesId: this.classesId,
    //       planclassesId: this.planclassesId
    //     })
    //     res && this.$message.success('添加成功')
    //     this.visible = false
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    // 删除贴子
    // async onDelete({ id }) {
    //   try {
    //     this.spinning = true
    //     const res = await deleteTheme(id)
    //     if (res) {
    //       this.$message.success('删除成功')
    //       this.findClassesDetailAsync(this.params)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.spinning = false
    //   }
    // },
    // quiz() {
    //   this.visible = true
    // },
    // uploadChange(ev) {
    //   this.form.photos = ev.join(',')
    // }
  }
}
</script>
<style lang="less" scoped>
.comments {
  padding-bottom: 28px;
  .ant-pagination {
    margin-top: 18px;
    text-align: center;
  }
}
.quiz {
  margin-left: 12px;
  border-radius: 16px;
  background-color: #1564ff;
}
.ant-form {
  margin-top: 16px;
  .ant-input {
    background: #f5f6fa;
    border-radius: 15px;
    border: none;
    padding-top: 12px;
  }
}
.ant-spin-nested-loading {
  min-height: 200px;
}
/deep/.ant-select-selection {
  border-radius: 16px;
}
</style>
